var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainNonBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 163 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xEB\xA0\x88\xEC\x9D\xB4\xEC\x96\xB4_2",
    clipPath: "url(#clip0_848_4489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M105.133 2.40045C104.192 0.343571 101.742 -0.571095 99.681 0.365879L2.40029 44.7963C0.343495 45.7377 -0.571132 48.1873 0.365803 50.2486L56.2384 172.6C57.1798 174.656 59.6292 175.571 61.6905 174.634L119.116 148.408L145.626 91.0918L105.133 2.40045Z",
    fill: "#D6E5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.5373 42.2714L21.7292 53.6038C19.4878 54.6276 18.5008 57.2746 19.5246 59.516L30.8565 84.3252C31.8803 86.5666 34.5272 87.5537 36.7685 86.5298L61.5767 75.1975C63.818 74.1736 64.805 71.5266 63.7812 69.2852L52.4493 44.476C51.4255 42.2346 48.7787 41.2476 46.5373 42.2714Z",
    fill: "#85B0E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.1724 44.8097C60.7313 44.8097 59.3572 43.9887 58.7191 42.5922C57.8491 40.687 58.6879 38.4383 60.593 37.5682L97.4592 20.7295C99.3643 19.8594 101.613 20.6982 102.483 22.6034C103.353 24.5086 102.514 26.7573 100.609 27.6274L63.7429 44.4662C63.2343 44.6982 62.6989 44.8097 62.168 44.8097H62.1724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M67.5618 56.1381C66.1207 56.1381 64.7466 55.3172 64.1086 53.9206C63.2385 52.0155 64.0773 49.7667 65.9824 48.8967L102.849 32.0579C104.754 31.1879 107.002 32.0267 107.872 33.9319C108.742 35.837 107.904 38.0858 105.998 38.9558L69.1323 55.7946C68.6237 56.0266 68.0883 56.1381 67.5574 56.1381H67.5618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M72.8577 67.7388C71.4166 67.7388 70.0425 66.9178 69.4045 65.5213C68.5344 63.6161 69.3732 61.3674 71.2783 60.4973L108.145 43.6586C110.05 42.7885 112.298 43.6273 113.168 45.5325C114.038 47.4377 113.199 49.6864 111.294 50.5565L74.4282 67.3952C73.9196 67.6272 73.3842 67.7388 72.8533 67.7388H72.8577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40.4221 101.564C39.5744 101.564 38.7669 101.082 38.3921 100.261C37.879 99.1408 38.3742 97.8156 39.4941 97.307L116.193 62.2775C117.313 61.7644 118.638 62.2597 119.147 63.3796C119.656 64.4995 119.165 65.8247 118.045 66.3333L41.3457 101.363C41.0467 101.501 40.73 101.564 40.4221 101.564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M46.5745 115.034C45.7268 115.034 44.9192 114.552 44.5444 113.731C44.0314 112.611 44.5266 111.286 45.6465 110.777L122.346 75.7477C123.466 75.2346 124.791 75.7298 125.299 76.8498C125.812 77.9697 125.317 79.2948 124.197 79.8035L47.498 114.833C47.1991 114.971 46.8823 115.034 46.5745 115.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M52.7271 128.504C51.8793 128.504 51.0718 128.022 50.697 127.201C50.1839 126.081 50.6792 124.756 51.799 124.247L128.498 89.2178C129.618 88.7047 130.943 89.1999 131.452 90.3198C131.961 91.4397 131.47 92.7649 130.35 93.2735L53.6506 128.303C53.3517 128.441 53.0349 128.504 52.7271 128.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M58.8752 141.974C58.0275 141.974 57.22 141.492 56.8452 140.671C56.3321 139.551 56.8274 138.226 57.9472 137.717L134.647 102.688C135.766 102.175 137.092 102.67 137.6 103.79C138.113 104.91 137.618 106.235 136.498 106.744L59.7988 141.773C59.4999 141.911 59.1831 141.974 58.8752 141.974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M65.0278 155.444C64.1801 155.444 63.3726 154.962 62.9978 154.141C62.4847 153.021 62.98 151.696 64.0998 151.187L140.799 116.158C141.919 115.645 143.244 116.14 143.753 117.26C144.261 118.38 143.771 119.705 142.651 120.214L65.9514 155.243C65.6525 155.382 65.3357 155.444 65.0278 155.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M145.631 91.0873L105.776 109.287C103.719 110.228 102.804 112.678 103.741 114.739L119.116 148.403L145.627 91.0873H145.631Z",
    fill: "#85B0E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.3,
    d: "M105.133 2.40045C104.192 0.343571 101.742 -0.571095 99.681 0.365879L2.40029 44.7963C0.343495 45.7377 -0.571132 48.1873 0.365803 50.2486L56.2384 172.6C57.1798 174.656 59.6292 175.571 61.6905 174.634L119.116 148.408L145.626 91.0918L105.133 2.40045Z",
    fill: "#305B82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M163 24.6379C163 22.1839 160.992 20.1761 158.538 20.1761H42.5368C40.0829 20.1761 38.0752 22.1839 38.0752 24.6379V170.538C38.0752 172.992 40.0829 175 42.5368 175H111.013L163 130.391V24.6379Z",
    fill: "#D6E5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M87.599 37.5771H57.2602C54.7961 37.5771 52.7986 39.5747 52.7986 42.0389V72.379C52.7986 74.8432 54.7961 76.8408 57.2602 76.8408H87.599C90.0631 76.8408 92.0606 74.8432 92.0606 72.379V42.0389C92.0606 39.5747 90.0631 37.5771 87.599 37.5771Z",
    fill: "#85B0E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M147.175 47.1699H103.214C101.122 47.1699 99.4221 45.47 99.4221 43.3774C99.4221 41.2848 101.122 39.5849 103.214 39.5849H147.175C149.267 39.5849 150.967 41.2848 150.967 43.3774C150.967 45.47 149.267 47.1699 147.175 47.1699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M147.384 60.7784H103.424C101.332 60.7784 99.6318 59.0784 99.6318 56.9859C99.6318 54.8933 101.332 53.1934 103.424 53.1934H147.384C149.477 53.1934 151.177 54.8933 151.177 56.9859C151.177 59.0784 149.477 60.7784 147.384 60.7784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M147.384 74.6099H103.424C101.332 74.6099 99.6318 72.9099 99.6318 70.8174C99.6318 68.7248 101.332 67.0248 103.424 67.0248H147.384C149.477 67.0248 151.177 68.7248 151.177 70.8174C151.177 72.9099 149.477 74.6099 147.384 74.6099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M146.938 93.3494H55.4754C54.244 93.3494 53.2446 92.3499 53.2446 91.1185C53.2446 89.887 54.244 88.8876 55.4754 88.8876H146.938C148.17 88.8876 149.169 89.887 149.169 91.1185C149.169 92.3499 148.17 93.3494 146.938 93.3494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M146.938 109.412H55.4754C54.244 109.412 53.2446 108.412 53.2446 107.181C53.2446 105.949 54.244 104.95 55.4754 104.95H146.938C148.17 104.95 149.169 105.949 149.169 107.181C149.169 108.412 148.17 109.412 146.938 109.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M146.938 125.474H55.4754C54.244 125.474 53.2446 124.475 53.2446 123.243C53.2446 122.012 54.244 121.012 55.4754 121.012H146.938C148.17 121.012 149.169 122.012 149.169 123.243C149.169 124.475 148.17 125.474 146.938 125.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M146.938 141.537H55.4754C54.244 141.537 53.2446 140.537 53.2446 139.306C53.2446 138.074 54.244 137.075 55.4754 137.075H146.938C148.17 137.075 149.169 138.074 149.169 139.306C149.169 140.537 148.17 141.537 146.938 141.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M146.938 157.599H55.4754C54.244 157.599 53.2446 156.6 53.2446 155.368C53.2446 154.137 54.244 153.137 55.4754 153.137H146.938C148.17 153.137 149.169 154.137 149.169 155.368C149.169 156.6 148.17 157.599 146.938 157.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M163 130.396H115.475C113.021 130.396 111.013 132.403 111.013 134.857V175.004L163 130.396Z",
    fill: "#85B0E2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_848_4489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 175,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainNonBoard);
export default __webpack_public_path__ + "static/media/main-non-board.fe320a680542fb2ea093ad458f11d926.svg";
export { ForwardRef as ReactComponent };